import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import PatientCard from "../patientUI/PatientCard";
import UnsPatientCard from "../patientUI/UnsPatientCard";


function DoctorUI() {
  const [patients, setPatients] = useState(null);
  const [unsPatients, setUnsPatients] = useState(null);

  useEffect(() => {
    const link = `/getMyPatients/${localStorage.getItem("user")}`;
    axios
      .get(link)
      .then((res) => {
        setPatients(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get("/unsignedPatients")
      .then((res) => {
        setUnsPatients(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  console.log(patients);

  let myPatientsMarkup = patients ? (
    patients.map((patient, i) => (
      <PatientCard patient={patient} key={i}></PatientCard>
    ))
  ) : (
    <p>loading</p>
  );

  let unsPatientsMarkup = unsPatients ? (
    unsPatients.map((patient, i) => (
      <UnsPatientCard patient={patient} key={i}></UnsPatientCard>
    ))
  ) : (
    <p>loading</p>
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={8} xs={12}>
        <h1>Your Patients</h1>
        <div className="shadow"
          style={{
            height: 600,
            overflowY: "scroll",
            borderRadius: 8,
          }}
        >
          {myPatientsMarkup}
        </div>
      </Grid>
      <Grid item sm={4} xs={12}>
      <h1>Free Patients</h1>
        <div className="shadow"
          style={{
            height: 600,
            overflowY: "scroll",
            borderRadius: 8,
          }}
        >
          {unsPatientsMarkup}
        </div>      </Grid>
    </Grid>
  );
}

export default DoctorUI;
